import { useNewCode } from '@calendly/feature-check-react'

export const useVatFlagAndCountryEnabled = (countryCode) => {
  // Check if:
  // 1) The VAT feature flag is enabled
  // 2) The given country code is in the VAT_ENABLED_COUNTRIES environment variable

  const isVatEuEnabled = useNewCode('monetization_vat_collection_eu_feature')?.enabled
  const isVatCanadaEnabled = useNewCode('monetization_vat_collection_ca_feature')?.enabled
  const isVatAussieEnabled = useNewCode('monetization_vat_collection_au_feature')?.enabled
  const isVatUkEnabled = useNewCode('monetization_vat_collection_uk_feature')?.enabled
  const isVatIndiaEnabled = useNewCode('monetization_vat_collection_in_feature')?.enabled

  if (!countryCode) return false

  const euCountries = [
    'AT', // Austria
    'BE', // Belgium
    'BG', // Bulgaria
    'CY', // Cyprus
    'CZ', // Czechia
    'DE', // Germany
    'DK', // Denmark
    'EE', // Estonia
    'ES', // Spain
    'FI', // Finland
    'FR', // France
    'GR', // Greece
    'HR', // Croatia
    'HU', // Hungary
    'IE', // Ireland
    'IT', // Italy
    'LT', // Lithuania
    'LU', // Luxembourg
    'LV', // Latvia
    'MT', // Malta
    'NL', // Netherlands
    'PL', // Poland
    'PT', // Portugal
    'RO', // Romania
    'SE', // Sweden
    'SI', // Slovenia
    'SK', // Slovakia
  ]

  const isVatCountryFeatureFlagEnabled = () => {
    switch (countryCode) {
      case 'CA':
        return isVatCanadaEnabled
      case 'AU':
        return isVatAussieEnabled
      case 'GB':
        return isVatUkEnabled
      case 'IN':
        return isVatIndiaEnabled
      default:
        return countryCode && euCountries.includes(countryCode) && isVatEuEnabled
    }
  }

  return isVatCountryFeatureFlagEnabled()
}
